<template>
  <div class="all-menu">
    <div
      v-for="(navChoice, index) in navChoicesModel"
      :key="index"
      v-b-tooltip.hover
      :title="`${navChoice.name || navChoice.link}`"
      class="component"
      :style="'width : ' + 100 / navChoicesModel.length + '%'"
      :class="{
        active: navChoice.active,
        left: index === 0,
        right: index === navChoicesModel.length - 1,
        'read-only': readOnly,
      }"
      @click="setNavChoice(index)"
    >
      <i :class="navChoice.icon"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'opportunities-menu',
  props: {
    navChoices: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      default: 'default',
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    navChoicesModel: {
      get() {
        return this.navChoices
      },
      set(navChoices) {
        this.$emit('input', navChoices)
      },
    },
  },
  mounted() {
    if (this.$route.query[`menu-${this.name}`]) {
      this.$emit('input', this.$route.query[`menu-${this.name}`])
      const navIndex = this.navChoicesModel.findIndex(
        (navChoice) => navChoice.link === this.$route.query[`menu-${this.name}`],
      )
      this.navChoicesModel[navIndex].active = true
    } else {
      let activeIndex = this.navChoicesModel.findIndex(({ active }) => active)
      activeIndex = activeIndex !== -1 ? activeIndex : 0

      this.navChoicesModel[activeIndex].active = true
      this.$emit('input', this.navChoicesModel[activeIndex].link)
    }
  },

  methods: {
    setNavChoice(index) {
      if (this.readOnly) return
      for (let i = 0; i < this.navChoicesModel.length; i++) {
        if (this.navChoicesModel[i].active === true) {
          this.navChoicesModel[i].active = false
        }
      }
      this.navChoicesModel[index].active = true
      const query = { ...this.$route.query }
      query[`menu-${this.name}`] = this.navChoicesModel[index].link
      this.$router.replace({ query })
      this.$emit('input', this.navChoicesModel[index].link)
    },
  },
}
</script>

<style lang="scss">
.read-only {
  cursor: auto;
}
</style>